import _JSXStyle from "styled-jsx/style";

if (typeof global !== "undefined") {
  Object.assign(global, { _JSXStyle });
}
